import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster as ShadcnToaster } from "@/components/ui/toaster";
import DealerLayout from "@/dealership/components/DealerLayout";
import Dashboard from "@/dealership/pages/Dashboard";
import Leads from "@/dealership/pages/Leads";
import LeadDetailPage from "@/dealership/pages/LeadDetailPage";
import Inventory from "@/dealership/pages/Inventory";
import InventoryDetailPage from "@/dealership/pages/InventoryDetailPage";
import Deals from "@/dealership/pages/Deals";
import DealDetailPage from "@/dealership/pages/DealDetailPage";
import Financials from "@/dealership/pages/Financials";
import FinancialsVehicleDetail from "@/dealership/pages/FinancialsVehicleDetail";
import Calendar from "@/dealership/pages/Calendar";
import Activities from "@/dealership/pages/Activities";
import BillOfSale from "@/dealership/pages/BillOfSale";
import PriceMatrix from "@/dealership/pages/PriceMatrix";
import Appraisals from "@/dealership/pages/Appraisals";
import AppraisalDetailPage from "@/dealership/pages/AppraisalDetailPage";
import Desking from "@/dealership/pages/Desking";
import DeskWorksheet from "@/dealership/pages/DeskWorksheet";
import DeskQuote from "@/dealership/pages/DeskQuote";
import DeskSettings from "@/dealership/pages/DeskSettings";
import DealerSettings from "@/dealership/pages/DealerSettings";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

export default function DealershipApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        {/* Full-page Bill of Sale (light-mode for printing) — no dealer layout */}
        <Route path="bill/:dealId" element={<BillOfSale />} />
        {/* Customer quote / internal worksheet print sheet — light-mode, no dealer layout */}
        <Route path="desking/:wsId/quote" element={<DeskQuote />} />
        <Route element={<DealerLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="leads" element={<Leads />} />
          <Route path="leads/:id" element={<LeadDetailPage />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="activities" element={<Activities />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="inventory/:id" element={<InventoryDetailPage />} />
          <Route path="pricing" element={<PriceMatrix />} />
          <Route path="appraisals" element={<Appraisals />} />
          <Route path="appraisals/:id" element={<AppraisalDetailPage />} />
          <Route path="desking" element={<Desking />} />
          <Route path="desking-settings" element={<DeskSettings />} />
          <Route path="desking/:wsId" element={<DeskWorksheet />} />
          <Route path="deals" element={<Deals />} />
          <Route path="deals/:id" element={<DealDetailPage />} />
          <Route path="financials" element={<Financials />} />
          <Route path="financials/vehicle/:id" element={<FinancialsVehicleDetail />} />
          <Route path="settings" element={<DealerSettings />} />
          <Route path="*" element={<Navigate to="/dealership" replace />} />
        </Route>
      </Routes>
      <ShadcnToaster />
    </QueryClientProvider>
  );
}
